import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext'; // 🔥 Import du contexte utilisateur

const MAX_MEDITATION_CREDITS = 10;

const MeditationCreditGauge = forwardRef((props, ref) => {
  const [credits, setCredits] = useState(null);
  const { t } = useTranslation();
  const { currentUser } = useAuth(); // 🔥 Récupération de l'utilisateur

  // 👉 Ne rien afficher si l'utilisateur est abonné
  if (currentUser?.subscriptionStatus === 'active') {
    return null;
  }

  const fetchCredits = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/check-credits`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await res.json();

      if (res.ok && typeof data.monthlyMeditationCredit === 'number') {
        setCredits(data.monthlyMeditationCredit);
      } else {
        console.warn('⚠️ Format de réponse inattendu :', data);
      }
    } catch (err) {
      console.error('❌ Erreur lors du fetch des crédits méditation :', err);
    }
  };

  useImperativeHandle(ref, () => ({
    refreshCredits: fetchCredits,
  }));

  useEffect(() => {
    fetchCredits();
  }, []);

  const percentage =
    credits !== null
      ? Math.min((credits / MAX_MEDITATION_CREDITS) * 100, 100)
      : 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', marginRight:1, mb:1 }}>
      <Box sx={{ position: 'relative', display: 'inline-flex', mr: 1 }}>
        <CircularProgress
          variant="determinate"
          value={100}
          size={16}
          thickness={5}
          sx={{ color: '#575757' }}
        />
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={16}
          thickness={5}
          sx={{
            color: '#FFF',
            position: 'absolute',
            left: 0,
          }}
        />
      </Box>

      <Typography sx={{ fontSize: 15, fontWeight: 500 }}>
        {credits !== null ? t('meditations_remaining', { count: credits }) : '...'}
      </Typography>
    </Box>
  );
});

export default MeditationCreditGauge;
